<template>
  <!-- TODO: 访客轨迹路径 -->
  <div id="bd-crm">
    <el-form ref="form" label-width="100px" size="mini">
        <el-form-item label="uid">
          <span v-html="currentVisitorInfo.uid" @click="copyTextToClipboard(currentVisitorInfo.uid)"></span>
        </el-form-item>
        <el-form-item :label="apiDescriptionTip">
          <span v-html="currentVisitorInfo.description" @click="copyTextToClipboard(currentVisitorInfo.description)"></span>
        </el-form-item>
        <el-form-item :label="nameTip">
            <el-link v-if="showEditName">{{ userCurrentCustomer.name }}</el-link>
            <el-input
                v-if="!showEditName"
                v-model="crm.name"
                :placeholder="inputContentTip"
                size="mini" clearable></el-input>
            <el-button
                v-if="showEditName2"
                type="text"
                icon="el-icon-edit"
                @click="switchEditName"
                size="mini"
                >{{ $t("edit") }}</el-button
            >
            <el-button
                v-if="!showEditName"
                icon="el-icon-check"
                @click="saveEditName"
                size="mini"
                >{{ $t("save") }}</el-button
            >
            <el-button
                v-if="!showEditName"
                icon="el-icon-close"
                @click="cancelEditName"
                size="mini"
                >{{ $t("cancel") }}</el-button>
        </el-form-item>
        <el-form-item :label="mobileTip">
            <el-link v-if="showEditMobile">{{
                userCurrentCustomer.mobile
            }}</el-link>
            <el-input
                v-if="!showEditMobile"
                v-model="crm.mobile"
                :placeholder="inputContentTip"
                size="mini" clearable></el-input>
            <el-button
                v-if="showEditMobile2"
                type="text"
                icon="el-icon-edit"
                @click="switchEditMobile"
                size="mini"
                >{{ $t("edit") }}</el-button
            >
            <el-button
                v-if="!showEditMobile"
                icon="el-icon-check"
                @click="saveEditMobile"
                size="mini"
                >{{ $t("save") }}</el-button
            >
            <el-button
                v-if="!showEditMobile"
                icon="el-icon-close"
                @click="cancelEditMobile"
                size="mini"
                >{{ $t("cancel") }}</el-button>
        </el-form-item>
        <el-form-item :label="emailTip">
            <el-link v-if="showEditEmail">{{ userCurrentCustomer.email }}</el-link>
            <el-input
                v-if="!showEditEmail"
                v-model="crm.email"
                :placeholder="inputContentTip"
                size="mini" clearable></el-input>
            <el-button
                v-if="showEditEmail2"
                type="text"
                icon="el-icon-edit"
                @click="switchEditEmail"
                size="mini"
                >{{ $t("edit") }}</el-button
            >
            <el-button
                v-if="!showEditEmail"
                icon="el-icon-check"
                @click="saveEditEmail"
                size="mini"
                >{{ $t("save") }}</el-button
            >
            <el-button
                v-if="!showEditEmail"
                icon="el-icon-close"
                @click="cancelEditEmail"
                size="mini"
                >{{ $t("cancel") }}</el-button
            >
        </el-form-item>
        <el-form-item :label="ageTip">
            <el-link v-if="showEditAge">{{ userCurrentCustomer.age }}</el-link>
            <el-input
                v-if="!showEditAge"
                v-model="crm.age"
                :placeholder="inputContentTip"
                size="mini" clearable></el-input>
            <el-button
                v-if="showEditAge2"
                type="text"
                icon="el-icon-edit"
                @click="switchEditAge"
                size="mini"
                >{{ $t("edit") }}</el-button
            >
            <el-button
                v-if="!showEditAge"
                icon="el-icon-check"
                @click="saveEditAge"
                size="mini"
                >{{ $t("save") }}</el-button
            >
            <el-button
                v-if="!showEditAge"
                icon="el-icon-close"
                @click="cancelEditAge"
                size="mini"
                >{{ $t("cancel") }}</el-button
            >
        </el-form-item>
        <el-form-item :label="jobTip">
            <el-link v-if="showEditJob">{{ userCurrentCustomer.job }}</el-link>
            <el-input
                v-if="!showEditJob"
                v-model="crm.job"
                :placeholder="inputContentTip"
                size="mini" clearable></el-input>
            <el-button
                v-if="showEditJob2"
                type="text"
                icon="el-icon-edit"
                @click="switchEditJob"
                size="mini"
                >{{ $t("edit") }}</el-button
            >
            <el-button
                v-if="!showEditJob"
                icon="el-icon-check"
                @click="saveEditJob"
                size="mini"
                >{{ $t("save") }}</el-button
            >
            <el-button
                v-if="!showEditJob"
                icon="el-icon-close"
                @click="cancelEditJob"
                size="mini"
                >{{ $t("cancel") }}</el-button
            >
        </el-form-item>
        <el-form-item :label="companyTip">
            <el-link v-if="showEditCompany">{{
                userCurrentCustomer.company
            }}</el-link>
            <el-input
                v-if="!showEditCompany"
                v-model="crm.company"
                :placeholder="inputContentTip"
                size="mini" clearable></el-input>
            <el-button
                v-if="showEditCompany2"
                type="text"
                icon="el-icon-edit"
                @click="switchEditCompany"
                size="mini"
                >{{ $t("edit") }}</el-button
            >
            <el-button
                v-if="!showEditCompany"
                icon="el-icon-check"
                @click="saveEditCompany"
                size="mini"
                >{{ $t("save") }}</el-button
            >
            <el-button
                v-if="!showEditCompany"
                icon="el-icon-close"
                @click="cancelEditCompany"
                size="mini"
                >{{ $t("cancel") }}</el-button
            >
        </el-form-item>
        <el-form-item :label="noteTip">
            <el-link v-if="showEditNote">{{
                userCurrentCustomer.description
            }}</el-link>
            <el-input
                type="textarea"
                :rows="2"
                v-if="!showEditNote"
                v-model="crm.description"
                :placeholder="inputContentTip"
                size="mini" clearable></el-input>
            <el-button
                v-if="showEditNote2"
                type="text"
                icon="el-icon-edit"
                @click="switchEditNote"
                size="mini"
                >{{ $t("edit") }}</el-button
            >
            <el-button
                v-if="!showEditNote"
                icon="el-icon-check"
                @click="saveEditNote"
                size="mini"
                >{{ $t("save") }}</el-button
            >
            <el-button
                v-if="!showEditNote"
                icon="el-icon-close"
                @click="cancelEditNote"
                size="mini"
                >{{ $t("cancel") }}</el-button
            >
        </el-form-item>
        <el-form-item :label="tagTip">
          <!-- 默认 -->
          <span v-if="showEditTags2">
            <el-tag size="mini" v-for="tag in userCurrentCustomer.tags" :type="tag.colorType" :key="tag.tid">{{ tag.name }}</el-tag>
          </span>
          <div v-if="!showEditTags && userTags.length === 0">{{ pleaseCreateTagFirstTip }}</div>
          <el-button v-if="showEditTags2" type="text" icon="el-icon-edit" @click="switchEditTags" size="mini">{{ $t('edit') }}</el-button>
          <!-- 编辑 -->
          <el-checkbox-group v-if="!showEditTags" v-model="tagNames" size="mini" style="margin-left: 10px;">
            <el-checkbox v-for="tag in userTags" :label="tag.name" :key="tag.tid"></el-checkbox>
          </el-checkbox-group>
          <el-button v-if="!showEditTags" icon="el-icon-check" @click="saveEditTags" size="mini">{{ $t('save') }}</el-button>
          <el-button v-if="!showEditTags" icon="el-icon-close" @click="cancelEditTags" size="mini">{{ $t('cancel') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
        <el-button size="small" @click="showEditCrmDrawer">{{ $t('edit') }}</el-button>
        </el-form-item> -->
        <el-form-item label="tid">
          <span v-html="userCurrentThread.tid" @click="copyTextToClipboard(userCurrentThread.tid)"></span>
        </el-form-item>
        <el-form-item label="topic">
          <span v-html="userCurrentThread.topic" @click="copyTextToClipboard(userCurrentThread.topic)"></span>
        </el-form-item>
    </el-form>
    <el-button class="el-icon-refresh" size="mini" @click="refresh" style="margin-left: 30px;">{{ $t("refresh") }}</el-button>
    <el-button size="mini" @click="showEditCrmDrawer" style="margin-left: 30px;">{{ $t("edit") }}</el-button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as https from "@/apis/http";
import bus from "@/util/eventbus";
const constants = require("@/util/constants");

export default {
  name: "bd-crm",
  data() {
    return {
      // 用户信息
      tagNames: [], //
      //
      inputVisible: false,
      inputValue: "",
      //
      crm: {
        id: 0,
        cid: "",
        name: "",
        email: "",
        mobile: "",
        age: 0,
        job: "",
        company: "",
        description: "",
        tid: "",
        tags: [],
        uid: "",
      },
      //
      showEditName: true,
      showEditMobile: true,
      showEditEmail: true,
      showEditAge: true,
      showEditJob: true,
      showEditCompany: true,
      showEditNote: true,
      showEditTags: true,
    };
  },
  computed: {
    ...mapGetters([
      "currentVisitorInfo",
      "userCurrentThread",
      "fingerPrints",
      "threadTags",
      "userTags",
      "userCurrentCustomer",
      "showAuthority",
    ]),
    apiDescriptionTip() {
      return this.$t("apiDescription");
    },
    nameTip() {
      return this.$t("name");
    },
    mobileTip() {
      return this.$t("mobile");
    },
    emailTip() {
      return this.$t("email");
    },
    ageTip() {
      return this.$t("age");
    },
    jobTip() {
      return this.$t("job");
    },
    companyTip() {
      return this.$t("company");
    },
    noteTip() {
      return this.$t("note");
    },
    tagTip() {
      return this.$t("tag");
    },
    inputContentTip() {
      return this.$t("inputContent");
    },
    showEditName2() {
      return (
        this.showEditName &&
        this.userCurrentThread.tid != null &&
        this.userCurrentThread.tid.trim().length > 0
      );
    },
    showEditMobile2() {
      return (
        this.showEditMobile &&
        this.userCurrentThread.tid != null &&
        this.userCurrentThread.tid.trim().length > 0
      );
    },
    showEditEmail2() {
      return (
        this.showEditEmail &&
        this.userCurrentThread.tid != null &&
        this.userCurrentThread.tid.trim().length > 0
      );
    },
    showEditAge2() {
      return (
        this.showEditAge &&
        this.userCurrentThread.tid != null &&
        this.userCurrentThread.tid.trim().length > 0
      );
    },
    showEditJob2() {
      return (
        this.showEditJob &&
        this.userCurrentThread.tid != null &&
        this.userCurrentThread.tid.trim().length > 0
      );
    },
    showEditCompany2() {
      return (
        this.showEditCompany &&
        this.userCurrentThread.tid != null &&
        this.userCurrentThread.tid.trim().length > 0
      );
    },
    showEditNote2() {
      return (
        this.showEditNote &&
        this.userCurrentThread.tid != null &&
        this.userCurrentThread.tid.trim().length > 0
      );
    },
    showEditTags2() {
      return (
        this.showEditTags &&
        this.userCurrentThread.tid != null &&
        this.userCurrentThread.tid.trim().length > 0
      );
    },
    pleaseCreateTagFirstTip() {
      return this.$t("pleaseCreateTagFirst");
    },
  },
  methods: {
    ...mapActions([
      "updateCurrentThreadNickname",
      "updateCurrentCustomer",
      "getUserTags",
      "getThreadTags",
      "getCustomerInfo",
      "getVisitorProfile"
    ]),
    //
    switchEditName() {
      this.showEditName = !this.showEditName;
      this.switchCommon();
    },
    switchEditMobile() {
      this.showEditMobile = !this.showEditMobile;
      this.switchCommon();
    },
    switchEditEmail() {
      this.showEditEmail = !this.showEditEmail;
      this.switchCommon();
    },
    switchEditAge() {
      this.showEditAge = !this.showEditAge;
      this.switchCommon();
    },
    switchEditJob() {
      this.showEditJob = !this.showEditJob;
      this.switchCommon();
    },
    switchEditCompany() {
      this.showEditCompany = !this.showEditCompany;
      this.switchCommon();
    },
    switchEditNote() {
      this.showEditNote = !this.showEditNote;
      this.switchCommon();
    },
    switchEditTags() {
      this.showEditTags = !this.showEditTags;
      this.switchCommon();
    },
    switchCommon() {
      this.crm = Object.assign({}, this.userCurrentCustomer);
      if (this.crm.name === "") {
        this.crm.name = this.userCurrentThread.nickname;
      }
      this.tagNames = [];
      if (this.crm.tags != null) {
        for (let i = 0; i < this.crm.tags.length; i++) {
          const tag = this.crm.tags[i];
          this.tagNames.push(tag.name);
        }
      }
    },
    saveEditName() {
      this.showEditName = !this.showEditName;
      this.createOrUpdateCrm();
    },
    cancelEditName() {
      this.showEditName = !this.showEditName;
    },
    saveEditMobile() {
      this.showEditMobile = !this.showEditMobile;
      this.createOrUpdateCrm();
    },
    cancelEditMobile() {
      this.showEditMobile = !this.showEditMobile;
    },
    saveEditEmail() {
      this.showEditEmail = !this.showEditEmail;
      this.createOrUpdateCrm();
    },
    cancelEditEmail() {
      this.showEditEmail = !this.showEditEmail;
    },
    saveEditAge() {
      this.showEditAge = !this.showEditAge;
      this.createOrUpdateCrm();
    },
    cancelEditAge() {
      this.showEditAge = !this.showEditAge;
    },
    saveEditJob() {
      this.showEditJob = !this.showEditJob;
      this.createOrUpdateCrm();
    },
    cancelEditJob() {
      this.showEditJob = !this.showEditJob;
    },
    saveEditCompany() {
      this.showEditCompany = !this.showEditCompany;
      this.createOrUpdateCrm();
    },
    cancelEditCompany() {
      this.showEditCompany = !this.showEditCompany;
    },
    saveEditNote() {
      this.showEditNote = !this.showEditNote;
      this.createOrUpdateCrm();
    },
    cancelEditNote() {
      this.showEditNote = !this.showEditNote;
    },
    saveEditTags() {
      this.showEditTags = !this.showEditTags;
      this.createOrUpdateCrm();
    },
    cancelEditTags() {
      this.showEditTags = !this.showEditTags;
    },
    showEditCrmDrawer() {
      bus.$emit(constants.EVENT_BUS_SHOW_CRM_DRAWER);
    },
    refresh() {
      this.getCustomerInfo()
      this.getVisitorProfile()
    },
    // handleTagDelete(tagid) {
    //   console.log("handleTagDelete:", tagid);
    // },
    showTagInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      console.log("handleInputConfirm:", this.inputValue);
      let tagName = this.inputValue;
      if (tagName) {
        //
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    // handleCommand(command) {
    //   this.$message("click on item " + command);
    // },
    //
    createOrUpdateCrm() {
      // console.log("crm 1: ", this.crm, this.tagNames);
      this.crm.tid = this.userCurrentThread.tid;
      // 将tags中对象转换为tag name
      // let tagNames = [];
      // if (this.crm.tags != null) {
      //   for (let i = 0; i < this.crm.tags.length; i++) {
      //     const tag = this.crm.tags[i];
      //     tagNames.push(tag.name);
      //   }
      // }
      this.crm.tags = this.tagNames;
      console.log("crm 2: ", this.crm);
      // if (this.crm.cid === null || this.crm.cid === "") {
      https.createCustomer(this.crm, (response) => {
          console.log("create customer success 1:", response);
          if (response.status_code === 200) {
            this.$message({
              showClose: true,
              message: response.message,
              type: "success",
            });
            this.addCrmDrawerVisible = false;
            //
            let customer = response.data
            // 更新会话列表中访客昵称
            this.updateCurrentThreadNickname(customer.name);
            this.updateCurrentCustomer(customer);
          } else {
            this.$message.error(response.message)
          }
        }, (error) => {
          console.log("create customer error", error);
          this.$message.error("create customer error")
        }
      );
      // }
      // else {
      //   https.updateCustomer(this.crm, (response) => {
      //       console.log("update customer success:", response);
      //       if (response != null && response.status_code === 200) {
      //         this.$message({
      //           showClose: true,
      //           message: response.message,
      //           type: "success",
      //         });
      //         this.addCrmDrawerVisible = false;
      //         // 
      //         let customer = response.data
      //         // 更新会话列表中访客昵称
      //         this.updateCurrentThreadNickname(customer.name);
      //         this.updateCurrentCustomer(customer);
      //       }
      //     }, (error) => {
      //       console.log("update customer error", error);
      //       this.$message.error("update customer error")
      //     }
      //   );
      // }
    },
    copyTextToClipboard(content) {
      //
      content = content.replaceAll("amp;", "");
      this.$message('"' + content + '" ' + this.$t("copiedToClip"));
      //
      var aux = document.createElement("input");
      aux.setAttribute("value", content);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
    },
  },
  mounted() {
    this.getUserTags();
  },
};
</script>

<style scoped>
#bd-crm {
  height: 100%;
  width: 100%;
  text-align: left;
}
.bd-user-tags {
  margin-top: 20px;
  margin-right: 5px;
}
.bd-input-new-tag {
  width: 78px;
  margin-top: 20px;
  margin-left: 5px;
  vertical-align: bottom;
}
.bd-new-tag {
  margin-top: 20px;
  margin-left: 10px;
}
</style>
